
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SoftUITabs from './SoftUITabs/SoftUITabs';
import Home from "./BrandingTabs/Home"
import News from "./BrandingTabs/News"
import SocialApp from "./BrandingTabs/SocialApp"
import SocialCelender from "./BrandingTabs/SocialCelender"
import Ghl from "./BrandingTabs/Ghl"
import Settings from "./BrandingTabs/Settings"
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import CopyToClipboard from "react-copy-to-clipboard";
import env from "config/env";
import { useAgencyInfo } from "context/agency";
import { useState } from "react";
import PropTypes from "prop-types";
import General from "./BrandingTabs/General"
import "./style.css"
import VideoContent from "./BrandingTabs/VideoContent";
import Category from "./BrandingTabs/Category";
import PricingMessgeText from "./BrandingTabs/PricingMessgeText";
import KeyBenefits from "./BrandingTabs/KeyBenefits";
import PricingHeadline from "./BrandingTabs/PricingPageHeadline";
import UpgradeBenefits from "./BrandingTabs/UpgradeBenefits";
import TrainYourAI from "./BrandingTabs/TrainYourAI";
import BespokeIntegrations from "./BrandingTabs/BespokeIntegrations";
import NonSaasPlanContactInfo from "./BrandingTabs/NonSaasPlanContactInfo";
import NotificationBanner from "./BrandingTabs/NotificationBanner";
import AccountactivationQoute from "./BrandingTabs/AccountactivationQoute";
import FAQ from "../FAQ";
import HelpCentre from "../HelpCentre";

function BasicInfo({
  handleSubmit,
  handleImage,
  loading,
  setbussiness_name,
  timezones_data,
  bussiness_name,
  categories,
  setCategories,
  setPricingPageMessage,
  pricing_page_message,
  setKeyBenefits,
  keyBenefits,
  setPricingPageHeadline,
  pricing_page_headline,
  upgrade_benefits,
  setUpgradeBenefits,
  setTrainYourAI,
  train_your_ai
}) {
  const customUrlDomain = env.ACCOUNT_LEVEL_URL
  const SERVER_IP = env.SERVER_IP;
  const [agency, Update] = useAgencyInfo();
  const [domainupdate, setDomainupdate] = useState(false);
  const [DefaultImage, setDefaultImage] = useState(agency?.Customization?.default_image || true);
  const [custom_color, setcustom_color] = useState(agency?.Customization?.custom_color || false);
  const [copy, setcopy] = useState(false);
  const [default_image_switch, setdefault_image_switch] = useState(false);
  const url = agency?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;
  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };
  const NewsFeedStatus = (e, val) => {
    handleSubmit(e, val)
  }
  const tabsData = [
    { label: 'General', content: <General handleImage={handleImage} handleSubmit={handleSubmit} loading={loading} /> },
    // { label: 'Home', content: <Home  handleImage={handleImage} handleSubmit={handleSubmit} /> },
    // { label: 'News', content: <News handleImage={handleImage} handleSubmit={handleSubmit} NewsFeedStatus={NewsFeedStatus}/> },
    { label: 'Your AI', content: <SocialApp handleImage={handleImage} handleSubmit={handleSubmit} loading={loading} /> },
    { label: 'Content Creation Calendar', content: <SocialCelender handleImage={handleImage} handleSubmit={handleSubmit} loading={loading} /> },
    // { label: 'GHL', content: <Ghl handleImage={handleImage} handleSubmit={handleSubmit} /> },
    { label: 'Video Branding', content: <VideoContent handleImage={handleImage} handleSubmit={handleSubmit} loading={loading} /> },
    { label: 'Categories', content: <Category categories={categories} setCategories={setCategories} handleImage={handleImage} handleSubmit={handleSubmit} loading={loading} /> },
    { label: 'Custom Pricing page message', content: <PricingMessgeText loading={loading} value={pricing_page_message} handleSubmit={handleSubmit} onChange={(e) => setPricingPageMessage(e.target.value)} /> },
    { label: 'Key Benefits', content: <KeyBenefits loading={loading} value={keyBenefits} handleSubmit={handleSubmit} onChange={(values) => setKeyBenefits(values)} /> },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          Account Activation Quote
          <Tooltip title="Customise the quote shown on your collect payment page of onboarding." placement="top">
            <InfoOutlinedIcon fontSize="small" color="dark" style={{ cursor: 'pointer' }} />
          </Tooltip>
        </span>
      ),
      content: <AccountactivationQoute loading={loading} />
    },
    { label: 'Pricing page headline', content: <PricingHeadline loading={loading} value={pricing_page_headline} handleSubmit={handleSubmit} onChange={(e) => setPricingPageHeadline(e.target.value)} /> },
    { label: 'Upgrade Benefits', content: <UpgradeBenefits loading={loading} value={upgrade_benefits} handleSubmit={handleSubmit} onChange={(values) => setUpgradeBenefits(values)} /> },
    { label: 'Train Your AI Agents loading screen', content: <TrainYourAI loading={loading} value={train_your_ai} handleSubmit={handleSubmit} onChange={(values) => setTrainYourAI(values)} /> },
    { label: 'Bespoke integrations Page', subLabel: '(Consult Maybe* Team before using)', content: <BespokeIntegrations loading={loading} agency={agency} Update={Update} /> },
    { label: 'Non-SaaS pricing Page - contact us information', subLabel: 'For clients not on a SaaS plan add the contact details of who they need to contact to discuss their account.', content: <NonSaasPlanContactInfo /> },
    { label: 'Notification banner', content: <NotificationBanner agency={agency} Update={Update} /> },
    { label: "Plans page FAQ's", subLabel: 'Customise up to four FAQs shown on your Plans page. Toggle any off, or edit the question and answer.', content: <FAQ /> },
    { label: 'Help Centre',  content: <HelpCentre /> },
    // { label: 'Settings', content: <Settings handleImage={handleImage} handleSubmit={handleSubmit} /> },
  ];

  return (
    <div className="container-alignment">
      <SoftBox p={3} display="flex" justifyContent="space-between" alignItems="center">
        <h1 className="headingpage-branding" >Branding</h1>
        {/* <SoftBox>
          <CopyToClipboard text={url} onCopy={handlecopy} sx={{ mr: 2 }}>
            <SoftButton variant="outlined" color="dark" size="small">
              {copy ? "Copied" : "Copy GHL Custom Menu URL"}
            </SoftButton>
          </CopyToClipboard>
        </SoftBox> */}
      </SoftBox>

      <SoftUITabs tabsData={tabsData} />
    </div>
  );
}
export default BasicInfo;
BasicInfo.propTypes = {
  setbussiness_name: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleImage: PropTypes.func.isRequired,
  bussiness_name: PropTypes.string.isRequired,
  timezones_data: PropTypes.arrayOf(PropTypes.object).isRequired,
};
